import Vue from 'vue';

window.profileCard = null

if (document.getElementById('fixed-person-hover-v1')) {

    Vue.component('profile-card', require('@/components/Profile/Card.vue').default);

    window.profileCard = new Vue({
        name: 'Profile Card',
        el: '#fixed-person-hover-v1'
    });
}
